import React, { useState, useEffect } from "react";
import { useFont } from "../../../contexts/FontContext/FontContext";
import styles from "./ExchangeFeedbackForm.module.css";

const ExchangeFeedbackForm = ( { choices, setRenderExchangeFeedbackForm, setRenderSelectNewItem, currentIndex, selectedProducts, flattenedProducts, setFlattenedProducts, selectedReason, setSelectedReason } ) => {
	const apiUrl = process.env.REACT_APP_API_URL;
	const fontFamilyOne = useFont().scheme_one;
	const [continueButtonClass, setContinueButtonClass] = useState("no_opacity");
	const maxChoices = 4;
	const reasonIndex = 0, subReasonsIndex = 1;

	useEffect(() => {
		if (choices && Object.keys(choices).length > 0) { setContinueButtonClass("fade_in"); }
	}, [choices]);

	//add or remove choice option from product's list of choices inside of flattenedProducts
	const toggleChoice = (choice) => {
		if (Object.keys(choices[choice][subReasonsIndex]).length > 0) { 
			setSelectedReason(choice); 
			return;
		} else {
			setFlattenedProducts(prev =>
			    prev.map(product => {
			    	if (product.unique_id === selectedProducts[currentIndex]) {
			        	const newChoices = { ...product.choices };
				        if (newChoices[choice]) { delete newChoices[choice]; }
				        else { 
				        	const choiceCopy = [...choices[choice]]; // shallow copy array
		          			choiceCopy[subReasonsIndex] = {}; // reset subReasons to empty
		          			choiceCopy.splice(2, 1); //get rid of defaultToggle 
		          			newChoices[choice] = choiceCopy;
				        }
					    return { ...product, choices: newChoices };
					}
				    return product;
			    })
		  	);
		}
	};

	//toggle sub choice option for a selected top level feedback reason
	const toggleSubChoice = (subChoiceId, subChoiceText) => {
	  	setFlattenedProducts(prev =>
		    prev.map(product => {
		      	if (product.unique_id === selectedProducts[currentIndex]) {
			        const newChoices = { ...product.choices }; // copy all choices for this product
			        if (newChoices[selectedReason]) {
			          	// shallow copy of the selectedReason's array
			       		const choiceCopy = [...newChoices[selectedReason]];
			          	const subReasons = { ...choiceCopy[subReasonsIndex] };
			          	if (subReasons[subChoiceId]) { delete subReasons[subChoiceId]; }		            	
			          	else { subReasons[subChoiceId] = subChoiceText; }
			          	choiceCopy[subReasonsIndex] = subReasons;
			          	newChoices[selectedReason] = choiceCopy;
			        } else { newChoices[selectedReason] = [choices[selectedReason][reasonIndex], {[subChoiceId]: subChoiceText}]; }
			        return { ...product, choices: newChoices };
			    }
		      	return product;
		    })
	  	);
	};

	//update other written text feedback area
	const updateWrittenFeedback = (e) => {
		const value = e.target.value;
		setFlattenedProducts(prev => prev.map(product => product.unique_id === selectedProducts[currentIndex] ? { ...product, written_feedback: value } : product) );
	};

	//log selected reasons and render choose new item view
	const submitFeedbackReasons = async () => {
		setRenderSelectNewItem(true);
		setRenderExchangeFeedbackForm(false);
	}

	return (
		<div className={`${styles.feedback_form_container} ${fontFamilyOne}`}>
			<div className={styles.feedback_choices_container}>
				<div className={styles.feedback_choices_wrapper}>
					{selectedReason ? (
						Object.entries(choices[selectedReason][subReasonsIndex]) || {}).map(([id, reason]) => (
							<div key={id} className={`${styles.feedback_choice_wrapper} ${Object.keys(choices[selectedReason][subReasonsIndex] || {}).length === maxChoices ? styles.fixed_height : styles.flex_grow}`} onClick={() => toggleSubChoice(id, reason)}>
								<img className={styles.feedback_choice_icon} src={`${process.env.PUBLIC_URL}/images/${flattenedProducts.find(product => product.unique_id === selectedProducts[currentIndex])?.choices?.[selectedReason]?.[subReasonsIndex]?.[id] ? "choice_selected.png" : "choice_unselected.png"}`} alt={"sub choice icon"} />
								<p className={styles.feedback_choice_text}>{reason}</p>
							</div>
						)
					) : (
						choices && (Object.entries(choices)).map(([id, reasonArr]) => (
								<div key={id} className={`${styles.feedback_choice_wrapper} ${Object.keys(choices).length === maxChoices ? styles.fixed_height : styles.flex_grow}`} onClick={() => toggleChoice(id)}>
									{Object.keys(reasonArr[subReasonsIndex]).length === 0 && (<img className={styles.feedback_choice_icon} src={`${process.env.PUBLIC_URL}/images/${flattenedProducts.find(product => product.unique_id === selectedProducts[currentIndex])?.choices?.[id] ? "choice_selected.png" : "choice_unselected.png"}`} alt={"choice icon"} />)}
									<p className={styles.feedback_choice_text}>{reasonArr[reasonIndex]}</p>
								</div>
							)
						)
					)}
				</div>
				<div className={styles.select_other_container}>
					<textarea className={`fade_in ${styles.other_text_area} ${fontFamilyOne}`} value={flattenedProducts.find(product => product.unique_id === selectedProducts[currentIndex])?.written_feedback || ""} placeholder={"Tell us more.."} maxLength={255} onChange={updateWrittenFeedback} />
				</div> 
				<div className={`${continueButtonClass} ${styles.feedback_continue_button}`} onClick={() => { submitFeedbackReasons(); }}>Choose item to receive in exchange</div>
			</div>
		</div>
	);
};

export default ExchangeFeedbackForm;